import _forEach from 'lodash/forEach'
import _find from 'lodash/find'

import { computed, reactive, toRaw } from 'vue'

import __ from '@/helper/translation'
import { clientData } from '@/stores/clientData'
import {
  isSelectedCarrierParcelIgnoreDeliveryData,
  isSelectedCarrierParcelMachine,
} from '@/stores/transport'
import isDelfiPhoneNumber from '../helper/delfi'

const stateClientDataFields = reactive([
  {
    id: 'recipient',
    name: 'recipient',
    label: '',
    placeholder: '',
    value: 'era',
    options: [
      {
        value: 'era',
        label: __('form.private_client_title'),
      },
      {
        value: 'jur',
        label: __('form.business_client_title'),
      },
    ],
    component: 'BooleanGroupField',
    visibility: ['default'],
    rules: ['required'],
  },
  {
    id: 'name',
    name: 'name',
    label: __('form.name_title'),
    placeholder: '',
    value: null,
    component: 'TextField',
    visibility: ['default'],
    rules: ['required'],
  },
  {
    id: 'surname',
    name: 'surname',
    label: __('form.surname_title'),
    placeholder: '',
    value: null,
    component: 'TextField',
    visibility: ['default'],
    rules: ['required'],
  },
  {
    id: 'data_firmName',
    name: 'firmName',
    label: __('form.company_name_title'),
    placeholder: '',
    value: null,
    component: 'TextField',
    visibility: ['legal'],
    rules: ['required'],
  },
  {
    id: 'data_firmCode',
    name: 'firmCode',
    label: __('form.company_code_title'),
    placeholder: '',
    value: null,
    component: 'TextField',
    visibility: ['legal'],
    rules: ['required'],
  },
  {
    id: 'email',
    name: 'email',
    label: __('form.email_title'),
    placeholder: '',
    value: null,
    component: 'TextField',
    visibility: ['default'],
    rules: ['email', 'required'],
  },
  {
    id: 'emailConfirmation',
    name: 'emailConfirmation',
    label: __('form.email_confirmation_title'),
    placeholder: '',
    value: null,
    component: 'TextField',
    visibility: ['default'],
    rules: ['email', 'required', 'confirmation:email' ],
  },
  {
    id: 'phone',
    name: 'phone',
    label: __('form.phone_title'),
    placeholder: '',
    value: '',
    component: 'PhoneField',
    visibility: ['default'],
    rules: ['required'],
  },
  {
    id: 'wantDelfi',
    name: 'wantDelfi',
    label: __('delfi.label'),
    placeholder: '',
    value: '',
    component: 'BooleanField',
    visibility: ['phoneCountry'],
    rules: [],
  },
  {
    id: 'address',
    name: 'address',
    label: __('form.address_title'),
    placeholder: __('form.address_title'),
    value: null,
    component: 'TextField',
    visibility: ['legal', 'courier', 'ignore'],
    rules: ['required'],
  },
  {
    id: 'town',
    name: 'town',
    label: '',
    placeholder: __('form.town_title'),
    value: null,
    component: 'TextField',
    visibility: ['legal', 'courier', 'ignore'],
    rules: ['required'],
  },
  {
    name: 'county',
    label: '',
    placeholder: __('form.county_title'),
    value: null,
    rules: ['required'],
    component: 'TextField',
    visibility: ['legal', 'courier', 'ignore'],
  },
  {
    id: 'postcode',
    name: 'postcode',
    label: '',
    placeholder: __('form.postal_code_title'),
    value: null,
    component: 'TextField',
    visibility: ['legal', 'courier', 'ignore'],
    rules: ['required'],
  },
])

export const clientDataFields = computed(() => {
  const collect = []

  const recipient = _find(stateClientDataFields, { name: 'recipient' })

  let isLegal = false
  if (recipient && clientData.value.recipient) {
    isLegal = clientData.value.recipient === 'jur'
  } else {
    isLegal = recipient.value === 'jur'
  }

  _forEach(stateClientDataFields, (field) => {
    let visible = false
    if (field.visibility.includes('default')) {
      visible = true
    }
    if (!visible && field.visibility.includes('legal') && isLegal) {
      visible = true
    }
    if (!visible && field.visibility.includes('phoneCountry')) {
      visible = isDelfiPhoneNumber(clientData.value.phone)
    }

    if (
      !visible &&
      !isSelectedCarrierParcelIgnoreDeliveryData.value &&
      field.visibility.includes('ignore')
    ) {
      visible = true
    }

    if (
      !visible &&
      field.visibility.includes('courier') &&
      !isSelectedCarrierParcelMachine.value &&
      !isSelectedCarrierParcelIgnoreDeliveryData.value
    ) {
      visible = true
    }

    field.value = clientData.value[field.name] || field.value
    field.required = field.rules && field.rules.includes('required')

    if (visible) {
      collect.push(field)
    } else {
      field.error = false
    }
  })

  return collect
})
